<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

          <SearchBar/>

          <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2 mb-1" icon="MenuIcon" @click.stop="showSidebar" />

          <vs-spacer />

          <a-popover trigger="click" placement="bottom" @visibleChange="visibleChange" :overlayStyle="{position:'fixed'}" overlayClassName="timeline">
              <template slot="title">
                <div class="notification-top text-center p-2 bg-primary text-white">
                  <h3 class="text-white">
                    <span v-if="time_line.length === 0">No Activities</span>
                    <span v-else-if="time_line.length === 1">1 Activity</span>
                    <span v-else>{{ time_line.length }} Activities</span>
                  </h3>
                  <div class="opacity-75">Timeline</div>
                </div>
              </template>
              <template slot="content">
                <ASpin :spinning="loading" :indicator="indicator">
                  <a-list item-layout="horizontal" :data-source="time_line">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                          <template slot="actions">{{ moment(item.created_at.$date) }}</template>
                          <a-list-item-meta>
                            <div slot="title" v-if="item.row.client">
                              <template v-if="item.row.client.person">
                                <a @click="goToPath(item.row.client.id)">
                                  {{ item.row.client.person.first_name }} {{ item.row.client.person.last_name }}
                                </a>
                              </template>
                              <template v-else>
                                <a @click="goToPath(item.row.client.id)">
                                  {{ item.row.client.company.name }}
                                </a>
                              </template>
                            </div>
                            <div slot="avatar">
                              <feather-icon icon="ClockIcon" class="mb-5" svg-classes="text-grey"></feather-icon>
                            </div>
                            <template slot="description">
                              {{ item.lawyer_user.first_name }} {{ item.lawyer_user.last_name }} {{ pastTenseOf[item.action] }} a {{ typeActivity(item.model) }} {{ item.model ==='matter' ?'' : item.row.title }}
                              <router-link v-if="item.model === 'matter'" :to="`/matters/dashboard/${item.row.id}`">{{ item.row.title }}</router-link>
                              <router-link v-else-if="item.row.matter" :to="`/matters/dashboard/${item.row.matter.id}`">{{ item.row.matter.title }}</router-link>
                            </template>
                          </a-list-item-meta>
                        </a-list-item>
                  </a-list>
                </ASpin>
              </template>
            <feather-icon @click="getTimeLine" class="sm:inline-flex cursor-pointer p-0 md:p-1" type="filled" icon="ClockIcon" svg-classes="text-primary" />
          </a-popover>

          <NotificationDropDown/>

          <Timer
            v-if="hasPermission('activity.time-entry.create')"
            @Timer="OpenTimer"
            @startTime="startTime"
            ref="timer"
          />

          <profile-drop-down />

        </vs-navbar>

        <a-modal centered :width="800" :visible="openActivities" title="New time entry" @cancel="openActivities = false">
        <a-form :form="form" @submit.prevent="handleSubmit">
          <div class="flex flex-col md:flex-row space-x-0 md:space-x-8">
            <div class="w-full md:w-1/2">
              <a-form-item label="Duration" has-feedback>
                <a-input
                  v-decorator="['duration',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'', required: false }] }]"
                  placeholder="recorded Time"
                  autocomplete="none"
                  addon-after="hour"
                  class="recorded_time"
                  style="width: 200px"
                  @keypress="onlyNumber"
                />
              </a-form-item>
              <SelectOption ref="user" url="/account/list/" label="User" field="user" :required="true" method="get" placeholder="Find A User" class="w-full"/>
              <a-form-item label="Headline" has-feedback>
                <a-select
                  v-decorator="['category',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                  class="select select-expense-type"
                  allowClear
                  placeholder="Times category"
                  option-label-prop="label"
                  show-search
                  :filter-option="filterOption"
                  @change="selectExpenseType"
                >
                  <!--                <div slot="dropdownRender" slot-scope="menu">-->
                  <!--                  <v-nodes :vnodes="menu" />-->
                  <!--                  <a-divider style="margin: 4px 0;" />-->
                  <!--                  <div-->
                  <!--                    style="padding: 8px 8px; cursor: pointer;color: #3A3DBE"-->
                  <!--                    @click="addCategoryToExpense"-->
                  <!--                  >-->
                  <!--                    <a-icon type="plus-circle" />  Create new time category-->
                  <!--                  </div>-->
                  <!--                </div>-->
                  <a-select-option v-for="item in time_categories" :label="item.name" :value="item.id">
                    {{ item.name }} ({{'$' + item.rate }})
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Description" has-feedback>
                <!-- <a-textarea
                  v-decorator="['description',{ rules: [{ required: false, message: 'Please input your username!' }] }]"
                  :rows="7"
                /> -->
				<vue-editor 
                v-decorator="[
                  'description',
                  {
                    initialValue: '',
                    valuePropName: 'value',
                    trigger: 'input',
                    getValueFromEvent: v => v,
                  }
                ]"
                :editorToolbar="customToolbar"
                class="w-full h-full"
              />
              </a-form-item>
            </div>
            <div class="w-full md:w-1/2">
              <selectSearch
                :required="true"
                url="/matter/query/"
                :options="optionSearchMatter"
                field="matter"
                label="Matters"
                class="self-center mt-8 md:mt-0 w-full"
                :is_include_matter="true"
                ref="activityMatter"
              />
              <a-form-item label="Date" has-feedback>
                <a-date-picker
                  v-decorator="['date',{ initialValue:new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This field is required.' }] }]"
                  placeholder="mm/dd/yyyy"
                  :format="dateFormat"
                  valueFormat="YYYY-MM-DD"
                />
              </a-form-item>
              <div class="flex space-x-2">
                <a-form-item label="Rate" has-feedback>
                  <input
                    v-decorator="['rate',{ initialValue: '0.00',rules: [{ required: false, message: 'Please input your username!' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'Select a valid rate.', required: false }] }]"
                    placeholder="0.00"
                    class="ant-input"
                    autocomplete="off"
                    @blur="convertToDecimal('rate',form)"
                  />
                </a-form-item>
                <p class="self-center md:self-end font-semibold text-sm text-gray-400 mt-3 md:mt-0">Default rate</p>
              </div>
              <div class="flex items-center">
                <a-form-item>
                  <a-checkbox
                    v-decorator="['is_no_billable',{ valuePropName:'checked' }]"
                  >
                    non-billable
                  </a-checkbox>
                </a-form-item>
                <a-icon class="self-start md:self-center mt-4 md:mt-0" type="info-circle" theme="twoTone" two-tone-color="#3A3DBE"/>
              </div>
            </div>
          </div>
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Save Entry
            </a-button>
            <!--<a-button color="primary" type="border" size="small">-->
            <!--  Save & create another-->
            <!--</a-button>-->
            <!--<a-button color="primary" type="border" size="small">-->
            <!--Save List Template-->
            <!--</a-button>-->
            <a-button type="primary" ghost @click="openActivities = false" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>

        </a-form>
      </a-modal>
<!--      <ModalActivity ref="timeEntry"/>-->

    </div>
  </div>
</template>

<script>
import Bookmarks            from './components/Bookmarks.vue'
import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import Timer      from '../timer/Timer'
import mixin from '../../../views/mixin/mixin'
import SelectOption from "../../../views/forms/SelectOptionSingle"
import selectSearch from "../../../views/forms/selectSearch"
import axios from "@/axios";
import moment from "moment";
import ModalActivity from "@/views/modal/ModalActivity";
import { VueEditor } from "vue2-editor"

export default {
  name: 'the-navbar-vertical',
  mixins:[mixin],
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  data(){
    return{
      /**
       * A readonly non-reactive variable.
       * Pass in a verb and get its past tense
       */
      pastTenseOf: {
        'create': 'created',
        'issue': 'issued',
        'edit': 'edited',
        'get': 'got',
        'remove': 'removed',
      },

      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      openActivities: false,
      isOnLine: navigator.onLine,
      time_line: [],
      time_categories: [],
      loading: false,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />
    }
  },
  components: {
    ModalActivity,
    Bookmarks,
    I18n,
    SearchBar,
    CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    Timer,
    SelectOption,
    selectSearch,
    VueEditor,
  },
  computed: {

    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    typeActivity(model) {
      switch (model) {
        case 'expense_category':
          return 'Expense Category'
        case 'time_entry':
          return 'Time Entry'
        case 'phone_log':
          return 'Phone Log'
        case 'note':
          return 'Note'
        case 'matter':
          return 'Matter'
        case 'event':
          return 'Event'
        case 'bill':
          return 'Bill'
        default:
          return model
      }
    },
    async getCategoryTimes(){
      try{
        const { data } = await axios.post('/activity/time-entry/category/query/',{limit:100})
        this.time_categories = data.rows
      }catch (e){
        throw e
      }
    },
    goToPath(path){
      this.$router.push({name:'dashboard-contact',params:{id: path}}).catch(()=>{})
    },
    async getTimeLine(){
      try{
        this.loading = true
        const {data} = await axios.post('/timeline/firm/')
        this.time_line = data
      }catch (e) {
        this.$message.error('Error receiving data.')
      }finally {
        this.loading = false
      }
    },
    visibleChange(val){
      if(val){
        this.time_line = []
      }
    },
    error() {
      this.$error({
        title: 'Check network',
        content: 'Please check your internet , then try again.',
      });
    },
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
    startTime(){
      this.stop_time = false
      // if(this.form.getFieldValue('duration'))
      //   this.$refs.timer.formattedElapsedTime = this.form.getFieldValue('duration') * 3600
    },
    OpenTimer(timeWithFormat,timeWithOutFormat){
      this.openActivities = true
      //this.timer(timeWithFormat,this.form,'duration')
      this.$nextTick(() => {
        this.form.setFieldsValue({ duration : (timeWithOutFormat / 3600).toFixed(4) })
      })
        //this.$refs.timeEntry.openActivities = true
      this.getCategoryTimes()

    },
    handleSubmit(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            await axios.post(`/activity/time-entry/`, values)
            if(this.$route.path === '/activities')
              this.$store.commit('FETCH_ACTIVITY',true)
            this.openActivities = false
            this.$notification['success']({
              message: 'Success',
              description: 'Time Entry created.',
            });
            this.form.resetFields()
            this.$refs.timer.formattedElapsedTime = 0
            this.$router.push('/activities').catch(()=>{})
          }catch (e){
            this.$notification['error']({
              message: 'Error',
              description: `Please try again.`,
            });
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    selectExpenseType(value) {
      const findCategoryTime = this.time_categories.find(item => item.id === value)
      this.form.setFieldsValue({ rate: findCategoryTime !== undefined ? findCategoryTime.rate : undefined })
    },
  },
  mounted() {
    //this.getTimeLine()
    window.addEventListener('online', ()=>{
      this.$message.success('Internet connected.').then(()=>this.isOnLine = true);
    });
    window.addEventListener('offline', ()=>{
      this.error().then(()=>this.isOnLine = false)
    });
  }
}
</script>


<style>
  @import "../../../views/style/style.css";
  [dir] .vx-navbar-wrapper{
    background: none !important;
  }
  .timeline .ant-popover-inner{
    max-height: 409px;
    overflow: auto;
  }
  .timeline .ant-popover-title {
    padding: 0 !important;
  }
  .timeline .ant-popover-arrow{
    border-color: rgb(58,61,190) !important;
  }
</style>
